import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { updateAddons } from '@custom/rtk-apis/Setting/addons/updateAddons';

const initialState = {
  result: null,
  loading: false,
  error: null,
  success: false,
  status: null,
};

// Create the slice
const updateAddonsSlice = createSlice({
  name: 'updateAddons',
  initialState,
  reducers: {
    resetUpdateAddons: (state) => {
      state.result = null;
      state.loading = false;
      state.error = null;
      state.success = false;
    },
    resetSuccess: (state) => {
      state.success = false;
    },
    resetError: (state) => {
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateAddons.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(updateAddons.fulfilled, (state, action: PayloadAction<any[]>) => {
        state.loading = false;
        state.result = action.payload;
        state.success = true;
        state.status = "SUCCESS";
      })
      .addCase(updateAddons.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
        state.success = false;
        state.status = "FAILED";
      });
  }
});

export default updateAddonsSlice.reducer;
export const { resetUpdateAddons, resetSuccess, resetError } = updateAddonsSlice.actions;
